// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"23b0fc38","4":"1c850048","236":"d6b0c284","338":"b84a38cb","342":"66186c41","375":"bf3f42ec","420":"004903f6","438":"6f9bb240","681":"a27cac67","757":"0f35217a"}[chunkId] + ".chunk.css";
};